import React from 'react'
import { Typography } from "@mui/material"
import { useUser } from "../../services/StateContext"
//import { getSplitName } from "../../services/utils"

const Title = (props) => {

    const { loading } = useUser()
     
    // const name  = user.nomePaciente ? user.nomePaciente : user.nomePessoa
    // const sexoP = user.sexoPaciente ? user.sexoPaciente : user.sexo

    //const { firstName } = getSplitName(name)
   
    if (loading) return null


    //const sexo = sexoP === 'M' ? 'Sr.' : 'Sra.'
    const { hidden, title, ...others } = props
   
    return <>
        {/* {!hidden && <Typography 
            variant="h4" 
            spacing={4} 
            component="h4" 
            sx={{fontSize: '1.2rem '}}
            >{sexo} {firstName}</Typography>} */}
        <Typography 
            
            variant="h3" 
            spacing={4} 
            component="h3"
            {...others} 
            
            
            mt={2}
        >{title}</Typography>
    </>
}

export default Title